export function downloadTemplate() {
    const csv = 'name,email\nJohn Smith,john@example.com\nJane Doe,jane@example.com';
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');

    a.href = url;
    a.download = 'Gifted Recipients Template.csv';
    a.click();

    window.URL.revokeObjectURL(url);
}

export function parseFile(file, settings) {
    return new Promise((resolve, reject) => {
        if (!file) {
            reject('No file provided');
            return;
        }

        window.Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            transformHeader: (header) => header.toLowerCase().trim(),

            complete: (results) => {
                try {
                    const validRecipients = results.data
                        .filter(row => row.email || row.name)
                        .map(row => ({
                            email: (row.email || '').trim(),
                            message: [],
                            name: (row.name || '').trim(),
                            personalisation: 'default',
                            salutation: '',
                        }));

                    if (validRecipients.length === 0) {
                        reject('No valid recipients found');
                        return;
                    }

                    if (validRecipients.length < settings.min) {
                        reject(`Minimum required recipients is ${settings.min}`);
                        return;
                    }

                    if (validRecipients.length > settings.max) {
                        reject(`Maximum allowed recipients is ${settings.max}`);
                        return;
                    }

                    validRecipients[0].personalisation = 'custom';

                    resolve(validRecipients);
                } catch (error) {
                    reject('Failed to parse CSV file');
                }
            },

            error: (error) => {
                reject(`CSV parsing error: ${error.message}`);
            },
        });
    });
}
